<div class="table-report-container">
  <table class="stripe" mat-table [dataSource]="dataTable" matSort [trackBy]="trackBy" [matSortDisabled]="!this.sortOn" (matSortChange)="this.sortChange()">
    <!-- Header Columns -->
    <ng-container [matColumnDef]="column.name" *ngFor="let column of this.tableDef.fields" [sticky]="false">
      <ng-container *ngIf="column.hideHeader; else headerTemplate">
        <th class="scnd-header unset-width-header" [ngClass]="filterOn ? 'no-bottom-border' : ''" mat-header-cell *matHeaderCellDef></th>
      </ng-container>
      <ng-template #headerTemplate>
        <th class="scnd-header" [ngClass]="filterOn ? 'no-bottom-border' : ''" mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="aip-header-cell">{{ column.title ? column.title : column.name }}</div>
        </th>
      </ng-template>

      <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="{
        'font-weight': column['bold'] ? 'bold' : '',
        'text-align': column['align'] ? column['align'] : '',
        'width': column['width'] ? column['width'] : '',
        'display': column['display'] ? column['display'] : ''
      }">
        <ng-container [ngSwitch]="column.type">
          <div *ngSwitchCase="'html'" [innerHTML]="element[column.name]" class="custom-column-html"></div>
          <ng-container *ngSwitchCase="'attachment'">
            <ul *ngIf="element[column.name]" class="custom-column-ul">
              <li *ngFor="let attachment of element[column.name]">
                <a (click)="downloadAttachment(element, attachment)" class="custom-column-link">
                  <span>{{ attachment }}</span>
                </a>
              </li>
            </ul>
          </ng-container>
          <span *ngSwitchCase="'datetime'" [matTooltip]="column.hovertext ? element[column.hovertext] : ''">{{ element[column.name] | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
          <span *ngSwitchDefault [matTooltip]="column.hovertext ? element[column.hovertext] : ''">
            <a *ngIf="column.accountlink; else columnTemplate" (click)="redirect(element, column.accountlink)" class="custom-column-link">
              <span>{{ element[column.name] }}</span>
            </a>
            <ng-template #columnTemplate>{{ element[column.name] }}</ng-template>
          </span>
        </ng-container>
      </td>
    </ng-container>

    <ng-container *ngIf="this.filterOn">
      <ng-container [matColumnDef]="column.name + '_filter'"
        *ngFor="let column of this.tableDef.fields" [sticky]="false">
        <th class="thrd-header" mat-header-cell *matHeaderCellDef>
          <input *ngIf="!column.hideFilter" [name]="column.name" class="aip-widget-search" matInput (keyup)="applyFilter($event)" placeholder="Filter">
        </th>
      </ng-container>
    </ng-container>

    <tr mat-header-row class="bottomheader aip-background-side" *matHeaderRowDef="headerColumnsArray; sticky: true"></tr>

    <ng-container *ngIf="this.filterOn">
      <tr mat-header-row class="filterheader aip-background-side" *matHeaderRowDef="headerColumnsFilterArray" sticky="true"></tr>
    </ng-container>

    <tr class="striperow" mat-row *matRowDef="let row; columns: headerColumnsArray;" (click)="clickRow(row)"
      (dblclick)="dblClickEdit(row)"></tr>
  </table>

</div>

<div class="aip-pagerflex">
  <div>
    <button class="aip-table-info" [matMenuTriggerFor]="menuExport" mat-icon-button>
      <fa-icon size="lg" icon="file-download"></fa-icon>
    </button>
    <mat-menu #menuExport="matMenu">
      <button class="aip-button" mat-menu-item (click)="export('xlsx')">
        <fa-icon size="lg" icon="file-excel"></fa-icon>Excel
      </button>
      <button class="aip-button" mat-menu-item (click)="export('csv')">
        <fa-icon size="lg" icon="file-csv"></fa-icon>CSV
      </button>
      <button class="aip-button" mat-menu-item (click)="export('json')">
        <fa-icon size="lg" icon="file-code"></fa-icon>JSON
      </button>
    </mat-menu>

    <button class="aip-table-info" matTooltip="Refresh Data" mat-icon-button (click)="reloadData()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
  <mat-paginator [ngClass]="this.pagedOn ? '' : 'aip-hide-page'" #paginator class="paginator-fullscreen"
    [pageSize]="pageSize" [pageIndex]="pageIndex" [length]="pageLength" [pageSizeOptions]="[25, 50, 100]"
    showFirstLastButtons (page)="pageChange()">
  </mat-paginator>
</div>
<div *ngIf="!this.pagedOn" class="bottom-fullscreen"></div>
